import { PageHero, ArrowCard, CTABand, Reveal } from "@/components/chrome";
import { SERVICES } from "@/data/services";
import { paths } from "@/lib/seo";

export default function ServicesIndex() {
  return (
    <div data-testid="services-index-page">
      <PageHero
        prefix="services-index"
        crumbs={[{ name: "Home", path: "/" }, { name: "Services" }]}
        eyebrow="All services"
        title="12 professional cleaning services, one Canadian network"
        lead="From weekly house cleaning to post-construction sparkle cleans — every service delivered by insured, background-checked local crews in 150+ cities across Canada. Flat-rate quotes by phone or email."
      />
      <section className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.06}>
              <ArrowCard to={paths.service(s.slug)} icon={s.icon} title={s.name} desc={s.tagline} testid={`service-card-${s.slug}`} />
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand lead="Not sure which service fits? Describe your space and we'll recommend — most quotes within one business hour." prefix="services-cta" />
    </div>
  );
}
